import {PUBLIC_PRODUCT_FILTER_CONFIG} from '@/submodule/decorate_manage/components/unit_edit_config_public.js'

const config = {
	product_list: [{
		tab: '轮播图设置',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '750,0',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '标题文字',
				type: 'input',
				code: 'title'
			}, {
				label: '链接',
				type: 'link',
				code: 'img_link'
			}]
		}]
	}, {
		tab: '商品设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: '标题颜色',
			type: 'color',
			code: 'title_color'
		}, {
			label: '按钮文字',
			type: 'input',
			code: 'button_text'
		}, {
			label: '按钮颜色',
			type: 'color',
			code: 'button_color'
		}, {
			label: '背景颜色',
			type: 'color',
			code: 'bg_color'
		}, {
			label: '背景图片',
			type: 'image',
			code: 'bg_img'
		}, {
			label: '边距',
			type: 'radio',
			code: 'margin',
			options: [{
				name: '无边距',
				value: 0
			}, {
				name: '有边距',
				value: 1
			}]
		}]
	}],
	
	waterfall_flow: [{
		tab: '系统推荐',
		content: [{
			label: '是否显示',
			type: 'radio',
			code: 'show',
			options: [{
				name: '显示',
				value: '1'
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '标题文字',
			type: 'input',
			code: 'title_text'
		}, {
			label: '副标题',
			type: 'input',
			code: 'sub_title'
		}]
	}, {
		tab: '自定义标签',
		content: [{
			type: 'list',
			code: 'tabs',
			length: 3,
			content: [{
				label: '是否显示',
				type: 'radio',
				code: 'show',
				options: [{
					name: '显示',
					value: '1'
				}, {
					name: '不显示',
					value: '0'
				}]
			}, {
				label: '标题文字',
				type: 'input',
				code: 'title_text'
			}, {
				label: '副标题',
				type: 'input',
				code: 'sub_title'
			}].concat(PUBLIC_PRODUCT_FILTER_CONFIG())
		}]
	}],
	
	channel_banner: [{
		tab: '内容设置',
		tips: '注：所有图片的尺寸需保持一致。',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '750,0',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其它设置',
		content: [{
			label: '显示方式',
			type: 'radio',
			code: 'show_type',
			options: [{
				name: '轮播',
				value: '1'
			}, {
				name: '平铺',
				value: '2'
			}]
		}]
	}]
}

export default config;